import { useState } from 'react';

import Select, { type SelectOption } from '@rio-cloud/rio-uikit/Select';

import { Playground } from '../../../components/playground/Playground';
import {
    PlaygroundClasses,
    PlaygroundResponsiveClasses,
    PlaygroundClassesSpacer,
    PlaygroundPrintClasses,
} from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';
import { Note } from '../../../components/Note';
import { Title } from '../../../components/Title';

import { spacings } from '../../../utils/spacings';

const spacingOptions: SelectOption[] = spacings.map(spacing => ({ id: spacing, label: `${spacing}px` }));
const spaceExampleItems = ['First child', 'Second child', 'Third child'];

export const Space = () => (
    <div>
        <Headline anchor='space'>Space</Headline>
        <Playground example={<SpaceExample />} classes={spaceClasses} />
        <Note>Use gap for flex or grid layouts.</Note>
    </div>
);

const SpaceExample = () => {
    const [spacing, setSpacing] = useState('20');

    const handleSpacingChange = (option: SelectOption | undefined) => setSpacing(option?.id ?? '20');

    return (
        <div>
            <div className='max-width-300 margin-bottom-25'>
                <Select
                    id='space-spacing-value'
                    label='Spacing'
                    options={spacingOptions}
                    value={[spacing]}
                    onChange={handleSpacingChange}
                />
            </div>
            <div className='display-grid grid-cols-1 grid-cols-2-md gap-20'>
                <div>
                    <Title>Horizontal</Title>
                    <div className='padding-15 overflow-hidden rounded bg-lightest'>
                        <div className={`space-x-${spacing}`}>
                            {spaceExampleItems.map(item => (
                                <span className='display-inline-block padding-10 rounded bg-info' key={item}>
                                    {item}
                                </span>
                            ))}
                        </div>
                        <div className='margin-top-15 text-center'>
                            <code className='bg-none'>{`space-x-${spacing}`}</code>
                        </div>
                    </div>
                </div>
                <div>
                    <Title>Vertical</Title>
                    <div className='padding-15 overflow-hidden rounded bg-lightest'>
                        <div className={`space-y-${spacing}`}>
                            {spaceExampleItems.map(item => (
                                <div className='padding-10 rounded bg-info' key={item}>
                                    {item}
                                </div>
                            ))}
                        </div>
                        <div className='margin-top-15 text-center'>
                            <code className='bg-none'>{`space-y-${spacing}`}</code>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const spaceClasses = (
    <>
        <PlaygroundClassesSpacer label='Pixel values' />
        <PlaygroundClasses label='Space X' prefix='space-x-' classes={spacings} />
        <PlaygroundClasses label='Space Y' prefix='space-y-' classes={spacings} />
        <PlaygroundClassesSpacer label='Negative pixel values' />
        <PlaygroundClasses label='Space X' prefix='space-x-' classes={['-1', '-2', '-3']} />
        <PlaygroundClasses label='Space Y' prefix='space-y-' classes={['-1', '-2', '-3']} />
        <PlaygroundResponsiveClasses />
        <PlaygroundPrintClasses />
    </>
);
